<template>
  <div>
    <div class="zjxRegister">
      <div class="zxj_register">
        <el-steps
          :active="active"
          finish-status="success"
          :align-center="alignCenter"
          :simple="simple"
        >
          <el-step title="注册信息"></el-step>
          <el-step title="基本信息"></el-step>
          <el-step title="信息审核"></el-step>
          <el-step title="会费缴纳"></el-step>
          <el-step title="提交审核"></el-step>
        </el-steps>
        <!-- 注册信息 -->
        <div v-show="active == 0" class="text_view">
          <div class="zxj_register__title">
            <p>注册</p>
          </div>

          <div class="register_left">
            <div class="form_register">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="姓名" prop="realName">
                  <el-input v-model="ruleForm.realName"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="idCard">
                  <el-input v-model="ruleForm.idCard"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                  <el-input
                    type="password"
                    v-model="ruleForm.password"
                  ></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="surePassword">
                  <el-input
                    type="password"
                    v-model="ruleForm.surePassword"
                  ></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                  <el-input v-model="ruleForm.phone"></el-input>
                </el-form-item>
                <el-form-item label="手机验证码" prop="phoneCode">
                  <div style="display: flex">
                    <el-input v-model="ruleForm.phoneCode"></el-input>
                    <el-button
                      class="specil_button"
                      @click="sendMessage"
                      :disabled="isDisabled"
                    >
                      {{ sendMsg }}
                    </el-button>
                  </div>
                </el-form-item>
                <el-form-item label="推荐人" prop="recommend" v-if="show">
                  <div style="display: flex">
                    <el-input v-model="ruleForm.recommend" disabled></el-input>
                    <el-button class="specil_button"> 扫码自动生成 </el-button>
                  </div>
                </el-form-item>
              </el-form>

              <el-button
                class="register_btn"
                @click.stop="submitForm('ruleForm')"
                >注册</el-button
              >
              <div class="register_radio">
                <el-radio v-model="outResource" @change="radioChange">
                  我已阅读并同意<span
                    style="color: #c22c25"
                    @click="openService"
                    >《服务协议和隐私政策》</span
                  >
                </el-radio>
              </div>
              <div class="register_radio">
                <el-radio v-model="outRequire" label="true">
                  我自愿加入中国建筑业协会会员
                </el-radio>
              </div>
            </div>
            <div class="registerRight">
              <div v-html="joinPaper"></div>
            </div>
          </div>

          <!-- 协议 -->

          <el-dialog
            title="服务协议和隐私政策"
            :visible.sync="centerDialogVisible"
            width="80%"
            center
          >
            <div v-html="register_paper"></div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="centerDialogVisible = false"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </div>

        <!-- 基本信息 -->
        <div v-show="active == 1">
          <div class="zxj_register__title">
            <p>基本信息</p>
          </div>
          <userBasicInfo
            :memberCode="memberCode"
            @addActive="basicFinsh"
          ></userBasicInfo>
        </div>
        <!-- 证书信息 -->
        <div v-show="active == 2">
          <div class="zxj_register__title">
            <p>证书信息</p>
          </div>
          <userCertiInfo
            :memberCode="memberCode"
            @prveStep="active--"
            @addActive="active++"
          >
          </userCertiInfo>
        </div>
        <!-- 会费缴纳 -->
        <div v-show="active == 3">
          <div class="zxj_register__title">
            <p>会费缴纳</p>
          </div>
          <userPayMember
            :memberCode="memberCode"
            @prveStep="active--"
            @addActive="active = active + 2"
          >
          </userPayMember>
        </div>
        <!-- 提交审核 -->
        <div v-show="active == 5">
          <div class="active_five">
            <img src="../../assets/img/webIndex/submit.png" alt="" />
            <p style="margin-top: 10px">恭喜您，注册完成</p>
            <p style="margin-top: 10px">请等待管理员审核</p>
            <p>
              期间您可以
              <span style="color: dodgerblue; cursor: pointer" @click="toLogin">
                登录系统
              </span>
              查看审核进度
            </p>
          </div>
        </div>
        <!-- 提交成功弹窗-->
        <el-dialog :visible.sync="botDialogVisible" width="350px" center>
          <div style="text-align: center">
            <p>您的基本信息符合要求！</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="botDialogVisible = false"
              >关闭</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import userBasicInfo from "./components/user_basicInfo.vue";
import userCertiInfo from "./components/user_certiInfo.vue";
import userPayMember from "./components/user_payMember.vue";
import { vaildate } from "../../utils/validate.js";
import {
  // userRegister,
  registerUser,
  sendMessage,
  registerPaper,
  getJoinPaper,
} from "../../api/moudles/user.js";
import { decrypt } from "@/utils/cryptoJS.js";
export default {
  data() {
    // 身份证验证
    const isCardId = (rule, value, callback) => {
      if (!value) {
        return new Error("请输入身份证号");
      } else {
        if (rule.field == "idCard") {
          if (!vaildate.isIdCard(value)) {
            callback(new Error("身份证号格式有误"));
          } else {
            callback();
          }
        }
      }
    };
    // 密码验证
    const isPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (!vaildate.isPassword(value)) {
        callback(new Error("密码长度不足6位"));
      } else if (!vaildate.CheckPassWord(value)) {
        callback(new Error("密码不符合规则"));
      } else if (this.ruleForm.surePassword) {
        if (value != this.ruleForm.surePassword) {
          callback(new Error("密码两次输入不一致"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const isCheckPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else if (!vaildate.isPassword(value)) {
        callback(new Error("密码长度不足6位"));
      } else if (!vaildate.CheckPassWord(value)) {
        callback(new Error("密码不符合规则"));
      } else if (value != this.ruleForm.password) {
        callback(new Error("密码两次输入不一致"));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电话号码"));
      } else if (!vaildate.isPhone(value)) {
        //判断用户输入的值是否符合规则
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
      }
    };
    return {
      is_admin: "",
      memberCode: "",
      joinPaper: "",
      show: false,
      simple: true,
      alignCenter: false,
      active: 0,
      outResource: "",
      outRequire: "",
      register_paper: "",
      disable: false,
      isDisabled: false,
      newNum: 60,
      sendMsg: "发送验证码",
      centerDialogVisible: false,
      botDialogVisible: false,
      ruleForm: {
        realName: "",
        idCard: "",
        password: "",
        surePassword: "",
        phone: "",
        phoneCode: "",
        recommend: "",
        resource: "",
      },
      rules: {
        realName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入身份证号码",
            trigger: "blur",
          },
          {
            validator: isCardId,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            validator: isPassword,
            trigger: "blur",
          },
        ],
        surePassword: [
          {
            required: true,
            message: "请确认输入密码",
            trigger: "blur",
          },
          {
            validator: isCheckPassword,
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "change",
          },
          {
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        phoneCode: [
          {
            required: true,
            message: "请输入手机验证码",
            trigger: "change",
          },
        ],
        resource: [
          {
            message: "请输入推荐人",
            trigger: "change",
          },
        ],
      },
    };
  },
  components: {
    userBasicInfo,
    userCertiInfo,
    userPayMember,
  },
  created() {
    const stepMember = JSON.parse(localStorage.getItem("stepMember"));
    if (stepMember) {
      this.active = parseInt(stepMember.step) - 1;
      this.memberCode = stepMember.memberCode;
    }

    this.registerPaper();
    this.joinPaperDetail();
    const screenWidth = window.screen.width;
    if (screenWidth < 760) {
      this.simple = false;
      this.alignCenter = true;
    } else {
      this.simple = true;
      this.alignCenter = false;
    }
    // memberCode
    // realName
  },
  mounted() {
    let query = {};
    if (this.$route.query && this.$route.query.memberCode) {
      this.ruleForm.recommend = decrypt(
        decodeURIComponent(this.$route.query.realName)
      );
      this.memberCode = decrypt(
        decodeURIComponent(this.$route.query.memberCode)
      );
      this.is_admin = decrypt(decodeURIComponent(this.$route.query.is_admin));
      query = {
        memberCode: this.$route.query.memberCode,
        realName: this.$route.query.realName,
        is_admin: this.$route.query.is_admin,
      };
    }
    const screenWidth = window.screen.width;
    if (screenWidth < 760 && this.$route.name == "register") {
      this.$router.replace({
        name: "phoneRegister",
        query,
      });
    }
    if (screenWidth > 760 && this.$route.name == "phoneRegister") {
      this.$router.replace({
        name: "register",
        query,
      });
    }
  },
  methods: {
    // 显示提交完信息的弹窗
    basicFinsh() {
      this.active++;
      this.botDialogVisible = true;
    },
    // 注册协议
    radioChange() {
      this.ruleForm.resource = true;
    },
    // 获取注册协议
    async registerPaper() {
      await registerPaper({
        success: (res) => {
          console.log("res", res);
          this.register_paper = res.data.registerPaper;
          this.show = res.data.isRecommend == "1";
        },
      });
    },
    // 获取入会须知
    async joinPaperDetail() {
      await getJoinPaper({
        success: (res) => {
          if (res.data) {
            this.joinPaper = res.data.joinPaper;
          }
        },
      });
    },
    // 发送注册短信
    async sendMessage() {
      if (this.disable) {
        this.$message.error(
          "短信验证码5分钟内只能发送一条，30分钟内有效，如果长时间未收到，请查看是否被短信拦截"
        );
        return;
      }
      if (!vaildate.isPhone(this.ruleForm.phone)) {
        this.$message.error("请检查手机号输入是否正确");
        return;
      }
      await sendMessage({
        data: {
          mobile: this.ruleForm.phone,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: "短信发送成功，请注意查收!",
              type: "success",
            });
            this.disable = true;
            setTimeout(() => {
              this.disable = false;
            }, 300000);

            this.sendMsg = "60s";
            this.isDisabled = true;
            let newInerl = setInterval(() => {
              this.sendMsg = this.newNum-- + "s";
            }, 1000);
            setTimeout(() => {
              this.newNum = 60;
              clearInterval(newInerl);
              this.sendMsg = "重新发送";
              this.isDisabled = false;
            }, 59000);
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    // 去登录
    toLogin() {
      if (window.screen.width < 760) {
        this.$router.replace("/phoneIndex/login");
      } else {
        this.$router.replace("/login");
      }
    },
    // 注册个人会员
    async registerUser() {
      await registerUser({
        data: {
          realName: this.ruleForm.realName,
          idCard: this.ruleForm.idCard,
          password: this.ruleForm.password,
          cellphone: this.ruleForm.phone,
          phoneCode: this.ruleForm.phoneCode,
          recommendMemberCode: this.memberCode,
          isAdmin: this.is_admin,
        },
        success: (res) => {
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.memberCode = res.data;
            setTimeout(() => {
              this.active++;
            }, 1500);
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        },
      });
    },
    // 打开协议
    openService() {
      this.centerDialogVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.outRequire) {
            this.$message({
              message: "请先勾选是否自愿加入中国建筑业协会会员",
              type: "warning",
            });
            return false;
          }
          if (this.ruleForm.resource) {
            this.registerUser();
          } else {
            this.$message({
              message: "请先阅读并同意《服务协议和隐私政策》",
              type: "warning",
            });
            return false;
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  beforeDestroy() {
    localStorage.removeItem("stepMember");
    localStorage.removeItem("stepCert");
    localStorage.removeItem("stepPay");
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .register_left {
    display: flex;
    padding: 20px;
    flex-wrap: wrap;
    flex-direction: column-reverse;
  }
}
@media screen and (min-width: 750px) {
  .register_left {
    display: flex;
    padding: 20px;
    flex-wrap: wrap;
  }
}

.registerRight {
  width: 350px;
  height: 450px;
  overflow-y: scroll;
  margin-top: 50px;
  border: 1px solid #eee;
  padding: 20px;
}
.active_five {
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-top: 50px;
}

>>> .el-step__head.is-success {
  color: #66b1ff;
  border-color: #66b1ff;
}

>>> .el-step__title.is-success {
  color: #66b1ff;
}

@media screen and (max-width: 750px) {
  .zjxRegister {
    min-height: 620px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .zxj_register {
    width: 100%;
    padding: 20px 0 60px 0;
    min-height: 600px;
    background-color: #fff;
  }

  .form_register {
    width: 90%;
    margin-left: 5%;
    padding-top: 50px;
  }

  .register_btn {
    width: 88%;
    margin-left: 6%;
    background-color: #c22c25;
    color: #fff;
  }

  .register_radio {
    width: 80%;
    margin-left: 10%;
    text-align: center;
    margin-top: 15px;
  }
}

@media screen and (min-width: 750px) {
  .zjxRegister {
    min-height: 710px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .zxj_register {
    width: 1200px;
    min-height: 650px;
    background-color: #fff;
  }

  .form_register {
    width: 36%;
    margin-left: 15%;
    margin-right: 5%;
    padding-top: 50px;
  }

  .text_view {
    text-align: center;
  }

  .register_btn {
    width: 332px;
    background-color: #c22c25;
    color: #fff;
  }

  .register_radio {
    text-align: center;
    margin-top: 15px;
  }
}

.specil_button {
  position: absolute;
  right: 0;
  border: none;
  margin-top: 3px;
  margin-right: 1px;
  padding: 10px 20px !important;
}

>>> .el-radio__input.is-checked .el-radio__inner {
  border-color: rgb(194, 44, 37);
  background: rgb(194, 44, 37);
}

>>> .el-radio__input.is-checked + .el-radio__label {
  color: rgb(194, 44, 37);
}

.zxj_register__title {
  height: 70px;
  width: 100%;
  border-bottom: 1px solid #f5f5f5;
  text-align: center;
  line-height: 70px;
  font-size: 22px;
}

:deep(.el-radio__inner) {
  border-radius: 2px;
}

:deep(.el-radio__input.is-checked) .el-radio__inner::after {
  content: "";
  width: 10px;
  height: 5px;
  border: 1px solid white;
  border-top: transparent;
  border-right: transparent;
  text-align: center;
  display: block;
  position: absolute;
  top: 2px;
  left: 0px;
  vertical-align: middle;
  transform: rotate(-45deg);
  border-radius: 0px;
  background: none;
}
</style>
